export const TENANT_OPTIONS_STORAGE_KEY = "tenantOptions";

export const USER_LANGUAGE_STORAGE_KEY = "userLang";
export const SUPPORT_LANGUAGES = 
  [
    { code: "en", name: "English" },
    { code: "fr", name: "French" },
  ];
export const DEFAULT_LANGUAGE = "en";

export const TENANT_OPTIONS_DEFAULT = {
    tenantId: undefined,
    tenantName: undefined,
    isGPEnabled: undefined,
  }